module.exports = "/images/header-background.80122745723b6ab3d245b13699041216.png";